import type { ReactNode } from "react";

interface StatsCardProps {
  icon: ReactNode;
  label: string;
  value: string | number;
  subtitle?: string;
  color?: "blue" | "green" | "red" | "yellow" | "purple";
}

const COLOR_MAP = {
  blue: "bg-primary-50 text-primary-600",
  green: "bg-success-50 text-success-600",
  red: "bg-danger-50 text-danger-600",
  yellow: "bg-warning-50 text-warning-600",
  purple: "bg-purple-50 text-purple-600",
};

export default function StatsCard({
  icon,
  label,
  value,
  subtitle,
  color = "blue",
}: StatsCardProps) {
  return (
    <div className="rounded-xl border border-gray-200 bg-white p-6 shadow-sm">
      <div className="flex items-center space-x-4">
        <div className={`flex h-12 w-12 items-center justify-center rounded-lg ${COLOR_MAP[color]}`}>
          {icon}
        </div>
        <div>
          <p className="text-sm font-medium text-gray-500">{label}</p>
          <p className="text-2xl font-bold text-gray-900">{value}</p>
          {subtitle && <p className="text-xs text-gray-400 mt-0.5">{subtitle}</p>}
        </div>
      </div>
    </div>
  );
}
